import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

/** 编辑短剧代码加载时对齐数据回填前的加载布局，不提前挂载表单或保存入口 */
export function VideoEditSkeleton() {
  return (
    <div className="p-6 space-y-6" aria-hidden="true">
      {/** 返回入口和编辑短剧标题 */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Skeleton className="h-9 w-9" />
          <Skeleton className="h-8 w-24" />
        </div>
      </div>
      <Card>
        <CardContent className="p-6">
          {/** 表单数据加载期间原页面保留 400px 的加载区 */}
          <div className="flex flex-col items-center justify-center min-h-[400px] w-full gap-2">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-5 w-16" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
